import { render, staticRenderFns } from "./ApplicationSteps.vue?vue&type=template&id=3488a396&"
import script from "./ApplicationSteps.vue?vue&type=script&lang=js&"
export * from "./ApplicationSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports